import React, { memo } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { GetTrackProps, SliderItem } from 'react-compound-slider';

interface IProps {
  source: SliderItem;
  target: SliderItem;
  getTrackProps: GetTrackProps;
}

const Track = ({ source, target, getTrackProps }: IProps) => (
  <div
    style={{
      position: 'absolute',
      height: 2,
      zIndex: 1,
      backgroundColor: '#000',
      borderRadius: 2,
      cursor: 'pointer',
      left: `${source.percent}%`,
      width: `${target.percent - source.percent}%`,
    }}
    {
      ...getTrackProps() /* this will set up events if you want it to be clickeable (optional) */
    }
  />
);

export default memo(Track);
